import type { OptionsDocument } from 'paintscout'

export function mapPublicToLeadSource({
  options,
  leadSource = ''
}: {
  options: OptionsDocument
  leadSource: string
}): string {
  const leadSourceEntry = Object.values(options?.options?.leadSources?.values || {}).find(
    (ls) => ls.label === leadSource || ls.name === leadSource
  )
  if (leadSourceEntry) {
    return leadSourceEntry.name
  }
  return ''
}
